  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-6">
        <h5 class="blue">
          <i class="fas fa-circle-info"></i>&nbsp;Detalles de carga: {{cargaRQ.cargaEstacion}}
        </h5>
      </div>
      <div class="col-6 align-items-end justify-content-end text-end">
        <div style="font-size: larger;" class="text-right">
          <span  (click)="onClose()" class="hoverable">
            <b>&times;</b>
          </span>
        </div>
      </div>
    </div>
    <hr style="margin-bottom: 0px;">
    <div class="row">
      <mat-tab-group animationDuration="0ms">
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="fas fa-pager" style="margin-right: 5px;"></i>
            Contenido
          </ng-template>
          <form #formEditarCarga="ngForm" (ngSubmit)="formSubmitEdit(formEditarCarga)" novalidate="">
            <div class="container-fuid" style="height: 540px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
              @if (seReenvio) {
                <div  class="row mt-3"  style="margin-right: 0px; margin-left: 0px;">
                  <div  class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button collapsed"  type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" style="padding: 4px;">
                          <i class="fa fa-check-double" style="margin-right: 3px;"> </i>
                          <b>La carga se ha reenviado con la siguiente justificación:</b>
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          {{ cargaRQ.Justificacion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                  <div class="form-group">
                    <label>Número Económico:</label>
                    <br>
                      <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                        [value]="cargaRQ.numeroActivo" >
                      </div>
                    </div>
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                        <label>Combustible:</label>
                        <br>
                          <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                            [value]="cargaRQ.combustibleCargado">
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                        <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                          <div class="form-group">
                            <label>Almac&eacute;n:</label>
                            <br>
                              <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                [value]="cargaRQ.almacen" >
                              </div>

                            </div>

                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="form-group">
                                <label>Hora de Carga:</label>
                                <br>
                                  <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                    [value]="cargaRQ.fechaCreacion | date: 'hh:mm aa' ">
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                                <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div class="form-group">
                                    <label>Transacci&oacute;n Lote:</label>
                                    <br>
                                      <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                        [value]="cargaRQ.transaccionMaximo" >
                                      </div>

                                    </div>

                                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                      <div class="form-group">
                                        <label>Equipo:</label>
                                        <br>
                                          <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                            [value]="cargaRQ.descripcion">
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                                        <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                          <div class="form-group">
                                            <label>N&uacute;mero de Empleado (Despachador):</label>
                                            <br>
                                              <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                                [value]="cargaRQ.numeroDespachador" >
                                              </div>

                                            </div>

                                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                              <div class="form-group">
                                                <label>N&uacute;mero de Empleado (Operador):</label>
                                                <br>
                                                  <input type="text" autocomplete="off" readonly
                                                    class="form-control form-control-sm custom-input" [value]="cargaRQ.numeroOperador">
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                                                <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                                  <div class="form-group">
                                                    <label>Despachador:</label>
                                                    <br>
                                                      <input type="text" autocomplete="off" readonly class="form-control form-control-sm custom-input"
                                                        [value]="cargaRQ.nombreDespachador" >
                                                      </div>

                                                    </div>

                                                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                                      <div class="form-group">
                                                        <label>Operador:</label>
                                                        <br>
                                                          <input type="text" autocomplete="off" readonly
                                                            class="form-control form-control-sm custom-input" [value]="cargaRQ.nombreOperador">
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                                                        <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                                          <div class="form-group">
                                                            <label>Litros:</label>
                                                            <br>
                                                              <div class="input-group">
                                                                <input type="number" autocomplete="off" [readonly]="!isEdit" autocomplete="off" step="0.2" placeholder="Litros a cargar"
                                                                  name="txtLitros" #txtLitros="ngModel" class="form-control form-control-sm custom-input-group"
                                                                  pattern="^(?:[1-9]|(?:[1-9][0-9])|(?:[1-4][0-9][0-9])|(?:499))(\.[0-9]{1,2})?$"   [(ngModel)]="cargaRQ.litrosCarga" required>
                                                                  <span class="input-group-text custom-input-group-text" ><i class="fas fa-tint"></i></span>
                                                                </div>
                                                                <small> Formato 0.00 (1 a 499.99) </small>
                                                              </div>
                                                            </div>

                                                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                                              <div class="form-group">
                                                                <label>Hor&oacute;metro:</label>
                                                                <br>
                                                                  <div class="input-group">
                                                                    <input type="number" autocomplete="off" [readonly]="!isEdit" autocomplete="off" step="0.2"  placeholder="Número de horómetro"
                                                                      name="txtHorometro" #txtHorometro="ngModel" class="form-control form-control-sm custom-input-group"
                                                                      pattern="^\d+(\.\d{1,2})?"   [(ngModel)]="cargaRQ.horometro" required>
                                                                      <span class="input-group-text custom-input-group-text" ><i class="fas fa-tachometer-alt"></i></span>
                                                                    </div>
                                                                    <small>   Formato 0.00 </small>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div class="row mt-2" style="margin-right: 0px;margin-left: 0px;">
                                                                <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
                                                                  <div class="form-group">
                                                                    <label>Observaciones:</label>
                                                                    <br>
                                                                      <textarea autocomplete="off" rows="2" [readonly]="!isEdit" class="form-control form-control-sm custom-input" placeholder="Observaciones"
                                                                      name="txtObservaciones" #txtObservaciones="ngModel" [(ngModel)]="cargaRQ.observaciones" ></textarea>
                                                                    </div>

                                                                  </div>
                                                                </div>
                                                              </div>

                                                              <div class="row mt-3 justify-content-center align-items-end text-center" style="margin-right: 0px;margin-left: 0px;">
                                                                @if (!isEdit) {
                                                                  <div class="col-lg-3 col-sm-3 col-md-3 col-3">
                                                                    <button (click)="controlEditCarga(formEditarCarga);" [disabled]="!isValid || noDetalles"
                                                                      type="button" class="btn btn-sm rounded-button btn-secondary"> <i class="far fa-edit"></i>&nbsp;Editar</button>
                                                                    </div>
                                                                    <div class="col-lg-3 col-sm-3 col-md-3 col-3 ">
                                                                      <button (click)="abrirModalEnviarCarga()" [disabled]="!isValid" type="button"
                                                                        class="btn btn-sm rounded-button btn-primary">
                                                                        <i class="far fa-paper-plane text-white"></i>&nbsp;
                                                                      {{ this.msgEnvio  }}     </button>
                                                                    </div>
                                                                    <div class="col-lg-3 col-sm-3 col-md-3 col-3 ">
                                                                      <button (click)="exportPDF(cargaRQ)" type="button" class="btn btn-sm rounded-button btn-danger">
                                                                        <i class="far fa-file-pdf"></i>&nbsp;PDF</button>
                                                                      </div>
                                                                      <div class="col-lg-3 col-sm-3 col-md-3 col-3">
                                                                        <button (click)="cancelLoad(cargaRQ.idCarga)" [disabled]="!isValid || noDetalles"  type="button"
                                                                          class="btn btn-sm rounded-button btn-danger">
                                                                          <i class="fas fa-times"></i>&nbsp;Cancelar</button>
                                                                        </div>
                                                                      }
                                                                      @if (isEdit) {
                                                                        <div class="col text-end">
                                                                          <button type="button" (click)="controlEditCarga(formEditarCarga);" class="btn btn-sm rounded-button btn-secondary">
                                                                            <i class="fa fa-arrow-left"></i>
                                                                            Regresar
                                                                          </button>
                                                                          <button type="submit" [disabled]="!formEditarCarga.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                                                                            Aceptar
                                                                            <i class="fa fa-check"></i>
                                                                          </button>
                                                                        </div>
                                                                      }
                                                                    </div>
                                                                  </form>
                                                                </mat-tab>
                                                                <mat-tab>
                                                                  <ng-template mat-tab-label>
                                                                    <i class="fas fa-image" style="margin-right: 5px;"></i>
                                                                    Imagen
                                                                  </ng-template>
                                                                  <div class="row align-items-center justify-content-center text-center mt-2" style="margin-right: 0px; margin-left: 0px;">
                                                                    <div class="col-lg-12">
                                                                      @if (cargaRQ.pathFoto) {
                                                                        <img class="img-fluid rounded" [src]="getImageSrc(cargaRQ.pathFoto)">
                                                                      } @else {
                                                                        <span class="h5"> <b>Sin imagen</b>  </span>
                                                                      }
                                                                    </div>
                                                                  </div>
                                                                </mat-tab>
                                                              </mat-tab-group>
                                                            </div>
                                                          </div>